<template>
  <div id="app">
    <PDFJSViewer style="width: 100%;" :path="`${path}`" :fileName="`${name}`"/>
  </div>
</template>

<script>
import PDFJSViewer from './PDFJSViewer'

export default {
  name: 'app',
  components: {
    PDFJSViewer
  },
  data () {
    return {
      name: 'sample.pdf', //change which pdf file loads
      path: 'lib/pdfjs-2.5.207-dist/web/viewer.html' //path of the PDF.js viewer.html
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(214 214 214);
  margin-top: 15px;
  width: 100%;
}
</style>